import React from 'react';
import { Select, Form } from 'antd';

const OVERTIME_THRESHOLD_VALUES = [40, 48];

export const OvertimeThresholdSelect = ({
  style,
  size,
}: {
  style?: object;
  size?: 'small' | 'middle' | 'large';
}) => (
  <Form.Item
    label="Overtime Threshold"
    name="overtimeThreshold"
    rules={[{ required: true }]}
    {...style}
  >
    <Select size={size}>
      {OVERTIME_THRESHOLD_VALUES.map((value) => {
        return (
          <Select.Option key={value} value={value}>
            {value} hours
          </Select.Option>
        );
      })}
    </Select>
  </Form.Item>
);
